(function($) {

  $.Control.extend(
    'pane_conditionalFormattingDisabled',
    {
      isAvailable: function() {
        return true;
      },

      getTitle: function() {
        return $.t('screens.ds.grid_sidebar.conditional_formatting_disabled.title');
      },

      getSubtitle: function() {
        return $.t('screens.ds.grid_sidebar.conditional_formatting_disabled.subtitle');
      },

      getDisabledSubtitle: function() {
        return '';
      },

      _getSections: function() {
        return [];
      },

      _getFinishButtons: function() {
        return [];
      },

      // Arguments provided to this method: 'data', 'value', 'finalCallback'
      _finish: function() {}
    },
    { name: 'conditionalFormattingDisabled' },
    'controlPane'
  );

  $(document).ready(function() {
    var showPane = _.get(window, 'socrata.gridView.sidebarPaneVisibility.filter.conditionalFormattingDisabled', false);

    if (showPane) {
      $.gridSidebar.registerConfig('filter.conditionalFormattingDisabled', 'pane_conditionalFormattingDisabled', 10);
    }
  });
})(jQuery);
